






























































































































































































































































































































































import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { validationMixin } from "vuelidate";

import LanguagesButtons from "../../buttons/languages-buttons.vue";
import { required, decimal, minValue } from "vuelidate/lib/validators";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import { ICategory, IProductCard } from "@/@types/menu/menu/menu";
import BSwitch from "../../app/switchs/b-switch.vue";
import UloadPicture from "../../app/images/upload-picture.vue";
import { preferred_language } from "@/config/languags.config.json";
import { ICoast } from "@/@types/_shared/coast";
import { ILocale } from "@/@types/locale";
import ChangeCategoryForm from "@/components/forms/menu/categorys/change-category-form.vue";
import { VueEditor } from "vue2-editor";
import axios from "@/api/AuthAPI/auth-request-api";
import { menu } from "@/config/host.config";
import { AxiosRequestConfig, AxiosResponse } from "axios";

@Component({
  components: {
    LanguagesButtons,
    SubmitResetButtonGroop,
    BSwitch,
    "upload-picture": UloadPicture,
    ChangeCategoryForm,
    VueEditor,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    category: { required },
    calorie: { decimal, minValue: minValue(0) },
  },
})
class AddDishForm extends Vue {
  @Inject({ from: "dishFolder", default: null }) readonly folder!: string;
  @Prop({ type: Array, default: [] }) categoryList!: ICategory[];
  @Prop({ type: String, default: "all-menu" }) activeBar!: string;
  @Prop({ type: Object, default: null }) dish!: IProductCard;

  locale = preferred_language;
  categoryFotrm = false;

  name = "";
  category: string | undefined = "";
  description = "";
  consist = "";
  type = "";
  srcImage = "";
  srcBackground = "";
  srcPoster = "";
  srcVerticalPoster = "";
  srcHorizontalPoster = "";
  font_size = "lead";
  show = false;
  delivery = false;
  availability = false;
  calorie: number | null = null;
  weight: Array<number | null> = [];
  rating = 0;
  coast: ICoast[] = [];
  names: ILocale = {};
  descriptions: ILocale = {};
  consists: ILocale = {};
  types: ILocale = {};
  coastElement: { value: number | null; currency: string } = {
    value: null,
    currency: "",
  };

  previewDemo: IProductCard | null = null;

  get product(): IProductCard {
    return {
      _id: this.dish ? this.dish._id : "",
      calorie: this.calorie,
      show: this.show,
      availability: this.availability,
      weight: this.weight.filter(
        (w) => w !== null && w !== undefined
      ) as Array<number>,
      category: this.category ? this.category : "",
      shop_id: this.activeBar,
      delivery: this.delivery,
      name: this.names,
      description: this.descriptions,
      consist: this.consists,
      type: this.types,
      rating: this.rating,
      params: [
        {
          name: {},
          coast: this.coast,
        },
      ],
      src: {
        image: this.srcImage,
        background: this.srcBackground,
        poster: this.srcPoster,
        vertical_poster: this.srcVerticalPoster,
        horizontal_poster: this.srcHorizontalPoster,
      },
    };
  }

  @Watch("srcImage")
  updateDemo(): void {
    this.$emit("updateDemo", this.product);
  }

  @Watch("coastElement", { deep: true })
  updateCoast(): void {
    if (this.coastElement.currency && this.coastElement.value) {
      for (const coast of this.coast) {
        if (this.coastElement.currency == coast.currency) {
          coast.currency = this.coastElement.currency;
          coast.value = this.coastElement.value;
          this.coastElement = {
            value: null,
            currency: "",
          };
          return;
        }
      }

      this.coast.push({
        value: this.coastElement.value,
        currency: this.coastElement.currency,
      });
      this.coastElement = {
        value: null,
        currency: "",
      };
    }
  }

  @Watch("name")
  updateName(): void {
    this.names[this.locale] = this.name;
    this.updateDemo();
  }

  @Watch("description")
  updateDescription(): void {
    this.descriptions[this.locale] = this.description;
    this.updateDemo();
  }

  @Watch("consist")
  updateConsist(): void {
    this.consists[this.locale] = this.consist;
    this.updateDemo();
  }

  @Watch("type")
  updateType(): void {
    this.types[this.locale] = this.type;
    this.updateDemo();
  }

  @Watch("locale")
  changeItemParams(): void {
    this.$emit("changeLanguage", this.locale);
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";

    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";

    if (this.consists)
      this.consist = this.consists[this.locale]
        ? this.consists[this.locale]
        : "";
    else this.consist = "";

    if (this.types)
      this.type = this.types[this.locale] ? this.types[this.locale] : "";
    else this.type = "";

    this.updateDemo();
  }

  getFullLangParams(): void {
    this.names = this.dish.name;
    this.descriptions = this.dish.description;
    this.consists = this.dish.consist;
    this.types = this.dish.type;

    this.calorie = this.dish.calorie;
    this.rating = this.dish.rating;
    this.show = this.dish.show;
    this.delivery = this.dish.delivery;
    this.availability = this.dish.availability;
    this.weight = this.dish.weight;
    this.coast = this.dish.params[0].coast ? this.dish.params[0].coast : [];
    this.category = this.dish.category;
    this.srcImage = this.dish.src.image;
    this.srcBackground = this.dish.src.background;
    this.srcPoster = this.dish.src.poster;
    this.srcVerticalPoster = this.dish.src.vertical_poster;
    this.srcHorizontalPoster = this.dish.src.horizontal_poster;
    this.changeItemParams();
  }

  getCategoryName(id: string): string {
    for (const cat of this.categoryList) {
      if (cat._id == id) return this.$getLocale(cat.name);
    }
    return "-";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");

      this.$v.$touch();
      return;
    }

    for (let i = 0; i < this.coast.length; i++) {
      if (!this.coast[i].currency || !this.coast[i].value)
        this.coast.splice(i, 1);
    }

    const id = this.dish ? this.dish._id : "";
    console.log(this.product);

    this.$emit("addNewDish", id, this.product);
  }

  onReset(): void {
    this.name = "";
    this.category = "";
    this.description = "";
    this.consist = "";
    this.type = "";
    this.calorie = null;
    this.show = false;
    this.delivery = false;
    this.availability = false;
    this.weight = [];
    this.coast = [];

    this.coastElement = {
      value: null,
      currency: "",
    };

    this.srcImage = "";
    this.srcBackground = "";
    this.srcPoster = "";
    this.srcVerticalPoster = "";
    this.srcHorizontalPoster = "";

    this.names = {};
    this.descriptions = {};
    this.types = {};
    this.consists = {};
  }

  async addNewCategory(id: string, category: ICategory): Promise<void> {
    const uri = menu.categorys;
    const config: AxiosRequestConfig = {};
    const categoryRes: AxiosResponse<ICategory> = await axios.post(
      uri,
      category,
      config
    );
    if (categoryRes.status === 200) {
      this.$emit("updateCategoryList", categoryRes.data);
      this.category = categoryRes.data._id;
    }
  }

  mounted(): void {
    if (this.dish && this.dish._id) this.getFullLangParams();
  }
}
export default AddDishForm;
